// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-data-container {
  margin-bottom: 1rem;
}
.no-data-card {
  margin-top: 133px;
  width: 92vw;
  height: 472px;
}

.card-inside-text {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
}

.card-inside-section .ant-image {
  display: flex;
  justify-content: center;
}
.no-data-card {
  margin-top: 3rem;
  width: 100%;
  height: auto;
}
.empty-view-image {
  margin: auto;
  padding-top: 56px;
  width: 150px !important;
  height: 212px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
}
.no-records-text {
  font-family: Roboto;
  text-align: center;
  margin-top: 31px;
}
.card-sub-text {
  font-family: Roboto;
  color: #000;
  margin-top: 10px;
  margin-bottom: 49px;
  font-size: var(--Font-Font-Size-p, 14px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  justify-content: center;
  display: flex;
  text-align: center;
}

.header-text {
  font-family: Roboto;
  color: #000;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  font-size: 17px;
  margin-bottom: 10px;
}

@media (min-width: 0px) and (max-width: 768px) {
  .no-data-card {
    width: 92vw;
  }
}
@media (max-width: 576px) {
  .no-records-text {
    margin-top: 20px;
  }
  .card-sub-text {
    margin-top: 0px;
    margin-bottom: 19px;
  }
  .header-text {
    font-size: 19px;
  }
  .empty-view-image {
    width: 100px !important;
    height: 100px !important;
    margin-top: 48px;
    padding-top: 0;
  }
}
@media (max-width: 1024px) {
  .no-data-card {
    width: 80% !important;
  }
}
@media (min-width: 1025px) {
  .no-data-card {
    width: 95% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/empty-view-card/EmptyViewCard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;EAChB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".no-data-container {\n  margin-bottom: 1rem;\n}\n.no-data-card {\n  margin-top: 133px;\n  width: 92vw;\n  height: 472px;\n}\n\n.card-inside-text {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  align-items: center;\n}\n\n.card-inside-section .ant-image {\n  display: flex;\n  justify-content: center;\n}\n.no-data-card {\n  margin-top: 3rem;\n  width: 100%;\n  height: auto;\n}\n.empty-view-image {\n  margin: auto;\n  padding-top: 56px;\n  width: 150px !important;\n  height: 212px;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n}\n.no-records-text {\n  font-family: Roboto;\n  text-align: center;\n  margin-top: 31px;\n}\n.card-sub-text {\n  font-family: Roboto;\n  color: #000;\n  margin-top: 10px;\n  margin-bottom: 49px;\n  font-size: var(--Font-Font-Size-p, 14px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  justify-content: center;\n  display: flex;\n  text-align: center;\n}\n\n.header-text {\n  font-family: Roboto;\n  color: #000;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  font-size: 17px;\n  margin-bottom: 10px;\n}\n\n@media (min-width: 0px) and (max-width: 768px) {\n  .no-data-card {\n    width: 92vw;\n  }\n}\n@media (max-width: 576px) {\n  .no-records-text {\n    margin-top: 20px;\n  }\n  .card-sub-text {\n    margin-top: 0px;\n    margin-bottom: 19px;\n  }\n  .header-text {\n    font-size: 19px;\n  }\n  .empty-view-image {\n    width: 100px !important;\n    height: 100px !important;\n    margin-top: 48px;\n    padding-top: 0;\n  }\n}\n@media (max-width: 1024px) {\n  .no-data-card {\n    width: 80% !important;\n  }\n}\n@media (min-width: 1025px) {\n  .no-data-card {\n    width: 95% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
